import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ChannelRateLimitsResponse } from '@troia-v3/types';
import { channelsApi } from '../services';

export const useRestoreChannelRateLimits = (channelId: string) => {
  const queryClient = useQueryClient();
  return useMutation<ChannelRateLimitsResponse, Error, void>({
    mutationFn: () => channelsApi.restoreRateLimits(channelId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels', channelId, 'rate-limits'] });
    },
  });
};
